import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getUpsellRevenue = {
  name: "getUpsellRevenue" as const,
  input: z.object({
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ revenue: z.number() }),
};
